export default {
    topics: [
        {
            title: ' jsapi-en ',
            href: 'p-1.html',
            attributes: { 'data-id': 'p-1' },
            menu: { hasChildren: true },
            tocID: 'p-1-d66e21',
            next: 'p-1-d66e21',
        },
        {
            title: 'SOAP Calls',
            href: 'p-14.html',
            menu: { hasChildren: true },
            tocID: 'tocId-d66e69',
            next: 'tocId-d66e69',
        },
        {
            title: 'Global functions',
            href: 'f-sqlExec.html',
            menu: { hasChildren: true },
            tocID: 'tocId-d66e4321',
            next: 'tocId-d66e4321',
        },
        {
            title: 'Objects, methods and properties',
            href: 'c-File.html',
            menu: { hasChildren: true },
            tocID: 'tocId-d66e4883',
            next: 'tocId-d66e4883',
        },
        {
            title: 'JavaScript Server Pages',
            href: 'p-32.html',
            menu: { hasChildren: true },
            tocID: 'tocId-d66e7579',
            next: 'tocId-d66e7579',
        },
    ],
};

